import { render, staticRenderFns } from "./search-history.vue?vue&type=template&id=09c6bd32&scoped=true&"
import script from "./search-history.vue?vue&type=script&lang=ts&"
export * from "./search-history.vue?vue&type=script&lang=ts&"
import style0 from "./search-history.vue?vue&type=style&index=0&id=09c6bd32&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09c6bd32",
  null
  
)

export default component.exports